module.exports = __webpack_public_path__ + "img/icon-drug-ticket.cb2908d1.svg";